// Libraries
import React, { useState, useEffect } from 'react';

// Data, Services and Contexts
import ratingsOverall from '../data/ratings/ratingsOverall-v1.json';
import ratingsByCategory from '../data/ratings/ratingsByCategory-v1.json';
import dma from '../services/dma';

const RatingsContext = React.createContext();

const RatingsProvider = ({ children }) => {
  const [ratings, setRatings] = useState({});

  useEffect(() => {
    setRatings({ overall: ratingsOverall, byCategory: ratingsByCategory });
  }, []);

  return (
    <RatingsContext.Provider
      value={{
        ratings,
        calculateRatings: dma.calculateRatings,
        calculateCategoryRating: dma.calculateCategoryRating
      }}>
      {children}
    </RatingsContext.Provider>
  );
};

export default RatingsContext;
export { RatingsProvider };
